<div class="w-100 d-flex flex-wrap pl-medium container">
  <div class="w-100">
    <span class="st-8 text-onback-medium">{{ data().title }}</span>
  </div>

  <div class="w-100 my-plus">
    <span class="c-2 text-onback-medium text-align-justify">{{ data().topDescription }}</span>
  </div>

  <div class="w-100 d-flex position-relative">
    <div class="d-flex gap-medium flex-column">
      @for (bullet of data().bullets; track $index) {
        <div class="d-flex align-items-start gap-tiny position-relative pros-desc-item">
          <div class="d-inline p-tiny radius-medium surface-brand mt-tiny"></div>
          <span class="c-2 text-align-justify">
            {{ bullet }}
          </span>
        </div>
      }
    </div>
  </div>

  <div class="w-100">
    <span class="text-align-justify">{{ data().bottomDescription }}</span>
  </div>

  <div class="mt-medium d-flex align-items-center w-100">
    <ngx-checkbox
      class="purchase-agreement"
      (checkedChange)="onToggleAgreement($event)"
      [checked]="agreementChecked()"
    >
    </ngx-checkbox>
    <div
      class="agreement-text c-3"
      (click)="onToggleAgreement(!agreementChecked())"
    >
      <span class="text-align-justify">شرایط بیانیه ریسک را می‌پذیرم.</span>
    </div>
  </div>
</div>

<div class="w-100 py-medium button-container surface-elevated">
  <ngx-button
    [fullWidth]="true"
    mode="form"
    [size]="'medium'"
    (clickHandler)="close()"
    [disabled]="!agreementChecked()"
  >
    تایید و ادامه
  </ngx-button>
</div>
